var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 57,
    fill: "none",
    viewBox: "0 0 54 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 0a2 2 0 0 0-2 2v5a2 2 0 1 0 4 0V6h20v1a2 2 0 1 0 4 0V6h5a5 5 0 0 1 5 5v38a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V11a5.002 5.002 0 0 1 3.522-4.778C7.314 5.977 8 5.328 8 4.5s-.678-1.515-1.492-1.361A8.003 8.003 0 0 0 0 11v38a8 8 0 0 0 8 8h38a8 8 0 0 0 8-8V11a8 8 0 0 0-8-8h-5V2a2 2 0 1 0-4 0v1H17V2a2 2 0 0 0-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDisplay);
export default __webpack_public_path__ + "static/media/calendar-display.1ffbdac3.svg";
export { ForwardRef as ReactComponent };